@if (name()) {
  <h2 class="text-2xl font-bold mb-5">Om mottagningen</h2>

  <div class="flex flex-col md:flex-row lg:flex-col gap-4">
    @if (image()) {
      <div class="item-image w-full h-36 md:w-64 md:min-w-64 md:h-44 lg:w-full lg:h-36 relative rounded">
        <img [alt]="name()" [ngSrc]="image()" [placeholderConfig]="{blur: false}"
             class="h-full w-full cursor-pointer object-cover object-[50%_30%] rounded-lg border border-grey-8"
             [attr.fetchpriority]="'high'"
             [priority]="true"
             fill="true"
             placeholder="data:image/png;base64,UklGRloAAABXRUJQVlA4IE4AAABQBwCdASqgAGQAP3G42GU0ryunIIgCkC4JaQAW30AntsReIBVVREKt3CqqIhceIVVREakRCqqJE4iIVVSXVURCqqAAAP7tqAAAAAAAAAA=">
      </div>
    }


    <div>
      <a [routerLink]="url()" class="text-duck-blue-2 text-xl font-bold">{{ name() }}</a>
      <div class="text-base text-grey-1 mb-4">{{ city() }}</div>

      @if (shortDesctiption()) {
        <div [innerHtml]="shortDesctiption()"
             class="text-base mb-4 line-clamp-3 text-grey-0"></div>
      }


      <a [routerLink]="url()" class="text-base text-duck-blue-2 flex justify-start items-center gap-1">
        <span>Läs mer om mottagningen</span>
        <app-ui-icon color="var(--duck-blue-2)" name="external"
                  size="sm"></app-ui-icon>
      </a>
    </div>
  </div>
}
